import { colorStrings, mediaQueriesBP } from "@iewcasia/Utilities/variables";
import { searchInputWidth } from "@iewcasia/WidgetExtensions/Header//MainNavigationExtension";
import { searchInputStyles as styles } from "@insite/content-library/Widgets/Header/SearchInput";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export const commonSearchHeaderStyles = {
    variant: "p",
    color: colorStrings.textMain,
    css: css`
        margin: 0;
        font-style: normal;
        font-size: 18px;
        line-height: 26px;
        padding: 20px 0 15px;
        border-bottom: 1px solid ${getColor(colorStrings.commonBorder)};
        margin-bottom: 10px;
        width: 100%;
    `,
} as TypographyPresentationProps;

styles.input = {
    ...styles.input,
    cssOverrides: {
        formField: css`
            width: auto;
            z-index: 2;
            color: ${getColor(colorStrings.textMain)};
        `,
    },
};

styles.autocompleteWrapper = {
    ...styles.autocompleteWrapper,
    css: css`
        flex-direction: column-reverse;
        gap: 20px;

        /* For Content/Categories/Brands */
        > div:first-child {
            flex: 1 1 38%;
            background-color: ${getColor(colorStrings.commonGlobalGray05)};
        }

        /* For Products */
        > div:last-child {
            flex: 1 1 60%;
            background-color: ${getColor(colorStrings.commonGlobalWhite)};
        }

        /* We use this media query to override and not use !important */
        ${mediaQueriesBP.maxMD} {
            flex-direction: column-reverse;
        }

        ${mediaQueriesBP.minLG} {
            display: flex;
            flex-direction: row-reverse;
            gap: 20px;
        }

        ${searchInputWidth};
    `,
};

styles.autocompleteColumnWrapper = {
    ...styles.autocompleteColumnWrapper,
    css: css`
        display: flex;
        flex-direction: column;
        padding: 16px;

        /* We use this media query to override and not use !important */
        ${mediaQueriesBP.maxMD} {
            flex-direction: column;
            padding: 16px;
        }

        ${mediaQueriesBP.minLG} {
            padding: 10px 40px 40px;
        }
    `,
};

styles.autocompleteProductsStyles = {
    ...styles.autocompleteProductsStyles,

    headerText: {
        ...commonSearchHeaderStyles,
    },
    titleLink: {
        typographyProps: {
            size: 18,
            css: css`
                margin: 0;
                width: 100%;
            `,
        },
    },
    erpNumberText: {
        color: colorStrings.textMain,
        variant: "legend",
        css: css`
            margin: 0;
            width: 100%;
        `,
    },
};

styles.autocompleteBrandsStyles = {
    ...styles.autocompleteBrandsStyles,

    headerText: {
        ...commonSearchHeaderStyles,
    },

    link: {
        typographyProps: {
            size: 14,
        },
    },

    brandItemText: {
        color: colorStrings.textMain,
        variant: "legend",
        css: css`
            margin: 0;
            width: 100%;
        `,
    },
};

styles.autocompleteContentStyles = {
    ...styles.autocompleteContentStyles,
    link: {
        typographyProps: {
            size: 14,
        },
    },

    headerText: {
        ...commonSearchHeaderStyles,
    },
};

styles.autocompleteCategoriesStyles = {
    ...styles.autocompleteCategoriesStyles,

    headerText: {
        ...commonSearchHeaderStyles,
    },

    link: {
        typographyProps: {
            size: 14,
        },
    },

    categoryItemText: {
        color: colorStrings.textMain,
        variant: "legend",
        css: css`
            margin: 0;
            width: 100%;
        `,
    },
};
